<template>
    <div :class="time<=10 ? 'hurry' : ''" class="Timer">
      <div class="timer-sec">
        <CanvasProgress :target="targetTime" :progress="time" />
        <div class="image-section"></div>
        <div class="elapsedtime">{{elapsed}}</div>
      </div>
      <!-- {{"Remaining time : " + elapsed}} -->
    </div>
</template>
<script>
    import { resetTime } from '../api/constants'
    import CanvasProgress from './canvas-progress'

    export default {
      data () {
        return {
          time: resetTime * 60,
          targetTime: resetTime * 60,
          timer: null
        }
      },
      watch: {
        setTime (newValue) {
          this.restartTimer(newValue)
        }
      },
      props: ['setTime'],
      computed: {
        elapsed () {
          let secs = this.time % 60
          let mins = (this.time - secs) / 60
          return `${mins > 9 ? mins : '0' + mins}:${secs > 9 ? secs : '0' + secs}`
        }
      },
      created: function () {
        this.startTimer()
      },
      beforeDestroy: function () {
        clearInterval(this.timer)
      },
      methods: {
        timeOut () {
          this.time--
          if (!this.time) {
            this.$router.push({name: 'Donations'})
          }
        },
        restartTimer (t) {
          this.time = Math.ceil(t * 60)
        },
        startTimer () {
          let vm = this
          this.timer = setInterval(vm.timeOut, 1000)
        }
      },
      components: {
        CanvasProgress
      }
    }
</script>
<style scoped>
  .hurry > .time {
    color: #ff971c;
  }
  .Timer {
    position: absolute;
    top: 20px;
    left: 30px;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;

  }
  div[dir='rtl'] .Timer {
    right: 30px;
    left: initial;
  }
  .timer-sec {
    /* background-image: url('/static/images/timer.png');
    background-size: 100% 100%; */
    width: 60px;
    height: 70px;
    position: relative;
  }
  .image-section {
    background-image: url('/static/images/timer.png');
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
  }
  .elapsedtime {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: 0 auto;
    font-size: 14px;
    color: #FFF;
    font-weight: 600;
    letter-spacing: 2px;
    width: 100%;
    height: 100%;
    margin-top: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media only screen and (min-width: 2000px) {
    .timer-sec {
      width: 245px;
      height: 270px;
    }
    .elapsedtime {
      font-size: 60px;
      line-height: 80px;
      margin-top: 15px;
    }
    .Timer {
      margin-top: 1.5%;
      margin-left: 5%;
    }
    div[dir='rtl'] .Timer {
      right: 5%;
      left: initial;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/timer.vue